import axios from 'axios'

export default {
    async create(model) {
        return await axios.post(`document-type`, model)
    },
    async fetchById(id) {
        return await axios.get(`document-type/${id}`)
    },
    async fetch(query, page) {
        return await axios.get(`document-type?q=${query}&page=${page}`)
    },
    async fetchDrivers() {
        return await axios.get(`user`)
    },
  
    async update(id, model) {
        return await axios.put(`document-type/${id}`, model)
    },
    async delete(id) {
        return await axios.delete(`document-type/${id}`)
    },
}
